import { render, staticRenderFns } from "./Section5th.vue?vue&type=template&id=f4be99ca&scoped=true&"
import script from "./Section5th.vue?vue&type=script&lang=js&"
export * from "./Section5th.vue?vue&type=script&lang=js&"
import style0 from "./Section5th.vue?vue&type=style&index=0&id=f4be99ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4be99ca",
  null
  
)

export default component.exports